var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[_c('h1',[_vm._v("Forbidden!")]),_c('h2',[_vm._v("Code 403")]),_c('button',{on:{"click":_vm.goBackToDashboard}},[_vm._v("Go back "+_vm._s(_vm.isBack ? '' : ' to dashboard')+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }